import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { AboutClub } from '../components/AboutClub';
import { MembershipBlock } from '../components/MembershipBlock';
import { EventsPreview } from '../components/EventsPreview';
import { ActivityCards } from '../components/ActivityCards';
import { SportingClaysSection } from '../components/SportingClaysSection';
import { EducationSafety } from '../components/EducationSafety';
import { PolicePistolCombat } from '../components/PolicePistolCombat';
import { FacilitiesSection } from '../components/FacilitiesSection';
import { LeaguesEvents } from '../components/LeaguesEvents';
import { QuickFacts } from '../components/QuickFacts';
import { TrainingOffered } from '../components/TrainingOffered';
import { NewsletterSignup } from '../components/NewsletterSignup';
import { LocationSection } from '../components/LocationSection';
import { AffiliationsStrip } from '../components/AffiliationsStrip';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <main className="w-full" data-id="element-506">
      <Header data-id="element-507" />
      <Hero data-id="element-508" />
      <AboutClub data-id="element-509" />
      <MembershipBlock data-id="element-510" />
      <EventsPreview data-id="element-511" />
      <ActivityCards data-id="element-512" />
      <SportingClaysSection data-id="element-513" />
      <EducationSafety data-id="element-514" />
      <PolicePistolCombat data-id="element-515" />
      <FacilitiesSection data-id="element-516" />
      <LeaguesEvents data-id="element-517" />
      <QuickFacts data-id="element-518" />
      <TrainingOffered data-id="element-519" />
      <NewsletterSignup data-id="element-520" />
      <LocationSection data-id="element-521" />
      <AffiliationsStrip data-id="element-522" />
      <Footer data-id="element-523" />
    </main>;
}